export interface SuccessResponse<T> {
  response: T
}

export const isSuccessResponse = (resp: ErrorResponse | SuccessResponse<unknown>): resp is SuccessResponse<any> => {
  return (resp as SuccessResponse<any>).response !== undefined
}

export interface ErrorResponse {
  errorMessage: string
  errorInfo?: string

  // If true you can make a toast with errorMessage
  isToast: boolean

  // Status has to be applied in the frontend
  status?: number
}

export type APIIntervals = 0 | 1 | 7 | 30
export type APIOrderings = 'votes' | 'uses' | 'saves' | 'newest' | 'name' | 'custom' | 'search' | 'random'
export type APIPremium = 'only' | 'hide' | 'all'

export type StripeAccountState = 'no account' | 'restricted' | 'complete'

export interface StripeAccountResponse {
  state: StripeAccountState
  ratio: number
}

interface StripeCurrency {
  available: number
  pending: number
}

export type StripeBalance = Record<string, StripeCurrency>

export type APIPromptTypeId = number

export type ItemType = 'all' | 'prompt' | 'list'

export enum PriceType {
  fixed = 1,
  fairPrice = 2,
}
